class TimeoutError extends Error {

}

function timeoutPromise(ms) {
  let resolve;
  const promise =  new Promise((_resolve, reject) => {
    const t = setTimeout( () => reject(new TimeoutError()), ms);
    resolve = () => { clearTimeout(t); _resolve() };
  });
  return { promise, resolve };
}

function findValue(results) {
  return results.find(({value}) => value)?.value;
}

async function parallelPromises(arr, fn, options = {}) {
  function getReturnValues() {
    if (timeout)
      timeoutResolve();
    if (!returnResults)
      return;
    return race ? findValue(results) : results;
  }
  const { skip = 0, returnResults = false, race = false, timeout = false, debug = false, stopPromise } = options;
  let { concurrency = 1 } = options;
  const active = new Set();
  const results = []
  let raceEnded = false;
  let stop = false;
  let timeoutResolve;
  if (skip) {
    arr = arr.slice(skip);
  }
  if (stopPromise)
    stopPromise.then(() => {
      debug && console.log('stopping');
      stop = true
    });
  if (timeout) {
    const { promise: timeoutPr, resolve: _timeoutResolve } = timeoutPromise(timeout);
    timeoutResolve = _timeoutResolve;
    active.add(timeoutPr);
    concurrency += 1;
  }
  let promise_i=0;
  for(const elem of arr) {
    while(active.size >= concurrency && !raceEnded && !stop) {
      if (raceEnded) {
        debug && console.log('race ended(1)');
        return getReturnValues();
      }
      try {
        debug && console.log(`concurrency limit reached (${active.size} >= ${concurrency}), waiting for promise to resolve/reject`);
        await Promise.race(active);
      } catch(e) {
        if (e instanceof TimeoutError) {
          debug && console.log('Timed out', e);
          return getReturnValues();
        }
      }
    }
    if (stop)
      break;
    if (raceEnded) {
      // TODO raceSuccess // raceAll // raceFailure
      debug && console.log('race ended(2)');
      return getReturnValues();
    }
    const promise = fn(elem).then((data) => {
      if (race)
        raceEnded = true;
      if (returnResults)
        results.push({ value: data });
      return { data };
    }).catch(error => {
      if (returnResults)
        results.push({ error });
      return { error };
    });
    promise.finally(() => active.delete(promise));
    active.add(promise);
    debug && console.log('started promise', ++promise_i);
  }
  debug && console.log('all queued promises started', active.size);
  // TODO race+timeout ??
  if (race || timeout) {
    while (timeout ? active.size > 1 : active.size) {
      try {
        const result = await Promise.race(active);
        if (race && result.data) {
          debug && console.log('race succeeded');
          return getReturnValues();
        }
        if (timeout && active.size === 1) {
          return getReturnValues();
        }
      } catch(e) {
        if (e instanceof TimeoutError) {
          return getReturnValues();
        }
      }
    }
    if (timeout && active.size === 1) {
      return getReturnValues();
    }
  }
  await Promise.allSettled(active);
  return getReturnValues();
}

export default parallelPromises;
